import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Tag, TagService } from '../_services/tag.service';

/**
 * Modal that sets the tags of some files to the checked project tags.
 * Closes with { tagged, tags } once saved; dismissed on Cancel.
 */
@Component({
    selector: 'app-tag-picker',
    templateUrl: './tag-picker.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagPickerComponent implements OnInit {
  @Input() projectId: string;
  /** the files to tag; their current tags start checked */
  @Input() files: { id: string, tags?: Tag[] }[];

  tags: Tag[];
  checked = new Set<string>();
  saving = false;
  error: string;

  constructor(public activeModal: NgbActiveModal, private tagService: TagService) { }

  ngOnInit() {
    this.files.forEach(file => (file.tags || []).forEach(tag => this.checked.add(tag.id)));

    this.tagService.list(this.projectId).subscribe({
      next: ({ tags }) => this.tags = tags,
      error: () => this.error = 'Failed to load the project tags',
    });
  }

  toggle(tagId: string) {
    if (!this.checked.delete(tagId)) { this.checked.add(tagId); }
  }

  confirm() {
    const tags = this.tags.filter(tag => this.checked.has(tag.id));
    this.saving = true;
    this.error = undefined;

    this.tagService.setFileTags(this.projectId, this.files.map(file => file.id), tags.map(tag => tag.id)).subscribe({
      next: ({ tagged }) => this.activeModal.close({ tagged, tags }),
      error: ({ error }) => {
        this.saving = false;
        this.error = [].concat(error?.message || 'Something went wrong!').join(', ');
      },
    });
  }
}
